import { flow } from "fp-ts/lib/function";

import { MetricField } from "../../gql-generated/types";
import { type InsightsMetrics, type InsightsMetricsMap, type StatsItem } from "../models";

import { mapCTRAverageValue } from "./mapCTRAverageValue";
import { mapCTRDiffValue } from "./mapCTRDiffValue";
import { mapCTRValueOverTime, mapCTRValueOverTimeFormatted } from "./mapCTRValueOverTime";
import { type TotalsMap } from "./mapFieldsToLifetimeTotalValues";

export const mapLensCTRData = (
    metrics: InsightsMetricsMap<StatsItem>,
    metricsPrevious: InsightsMetricsMap<StatsItem>,
    lensCTRObj: InsightsMetrics<StatsItem> | undefined,
    lifetimeTotals?: TotalsMap,
): InsightsMetrics<StatsItem> | undefined => {
    const swipeUps =
        (lifetimeTotals ? lifetimeTotals[MetricField.SwipeUps] : metrics[MetricField.SwipeUps]?.totalValue) ?? 0;
    const swipeUpsPrev = metricsPrevious[MetricField.SwipeUps]?.totalValue ?? 0;

    const lensPlays =
        (lifetimeTotals ? lifetimeTotals[MetricField.LensPlays] : metrics[MetricField.LensPlays]?.totalValue) ?? 0;
    const lensPlaysPrev = metricsPrevious[MetricField.LensPlays]?.totalValue ?? 0;

    if (!lensCTRObj) {
        return undefined;
    }

    return flow(
        mapCTRAverageValue,
        mapCTRValueOverTime({ swipeUps, lensPlays }), // sets valueOverTime
        mapCTRValueOverTimeFormatted, // sets valueOverTimeFormatted
        mapCTRDiffValue(
            [
                { swipeUps, lensPlays },
                { swipeUps: swipeUpsPrev, lensPlays: lensPlaysPrev },
            ],
            !!lifetimeTotals,
        ), // sets diffValue
    )(lensCTRObj);
};
